import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';

// Bootstrap Imports
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

const CtaContact = () => {
	return (
		<Container>
			<Card
				className='cta-card'
				style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
				<Card.Body>
					<Card.Title style={{ color: '#fff' }}>
						¿Te gustaría conocer mi propuesta de valor?
					</Card.Title>
					<LinkContainer
						to={'/signup/'}
						style={{ fontWeight: 500, minWidth: 190 }}>
						<Button
							variant=''
							size='lg'
							className='cta-hero-btn btn-rounded px-4'>
							Contáctame
						</Button>
					</LinkContainer>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default CtaContact;
